import { deprecated } from '../../../constants/texts';

export default class Link extends React.PureComponent {
  componentDidMount() {
    console.warn('eDoCat Router Link -- ', deprecated);
  }

  onClick(event) {
    event.preventDefault();
    const { to } = this.props;
    window.location.hash = to;
  }

  render() {
    const { to, children, title, className } = this.props;

    return (
      <a href={to} className={`Edocat-Router-Link ${className}`} onClick={::this.onClick} title={title}>
        {children}
      </a>
    );
  }
}
